import {radialProgressiveBlur} from '@remotion/effects/radial-progressive-blur';
import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	Composition,
	Easing,
	HtmlInCanvas,
	interpolate,
	useCurrentFrame,
} from 'remotion';
import {CloseUpFrame} from './CloseUpFrame';

const CloseUp4Content = () => {
	const frame = useCurrentFrame();
	const captureFrame = frame + 400;

	return (
		<HtmlInCanvas
			name="Canvas Capture"
			width={3924}
			height={1716}
			style={{
				width: 3924,
				height: 1716,
				translate: '-2192.6px -834.1px',
				rotate: '0.984657 -0.15615 0.077899 41.996034deg',
				scale: 0.996,
			}}
			from={-400}
			effects={[
				radialProgressiveBlur({
					center: [0.759, 0.827],
					rotation: 31,
					start: 0.71,
					endBlur: 18,
				}),
			]}
		>
			<Video
				src="https://remotion.media/studio-close-ups/studio-crop-editing.mp4"
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(captureFrame, [11, 174], ['ew-resize', 'auto'], {
					easing: [Easing.step1],
					extrapolateLeft: 'clamp',
					extrapolateRight: 'clamp',
				})}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(captureFrame, [0, 388, 531], [4, 3.6, 4], {
						easing: [Easing.step1, Easing.step1],
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					}),
					translate: interpolate(
						captureFrame,
						[
							11, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 316, 317,
							318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330,
							331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343,
							344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 358, 359, 360,
							361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373,
							374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 384, 385, 386,
							387, 402, 403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413,
							414, 415, 416, 417, 418, 419, 420, 421, 422, 423, 424, 425, 426,
							427, 428, 429, 430, 431, 441, 442, 443, 444, 445, 446, 447, 448,
							449, 450, 451, 452, 453, 454, 455, 456, 457, 458, 459, 460, 461,
							462, 463, 464, 465, 466, 469, 470, 471, 472, 473, 474, 485, 486,
							487, 488, 489, 490, 491, 492, 493, 494, 495, 496, 497, 498, 499,
							500, 501, 502, 503, 504, 505, 506, 507, 508, 509, 510, 511, 512,
							513, 514, 515, 516, 517, 518, 519, 520, 521, 522, 523, 524, 525,
							526, 527,
						],
						[
							'51.703125px 578.625px',
							'51.703125px 578.625px',
							'2088.15625px 1325.71875px',
							'2088.15625px 1325.71875px',
							'2078.375px 1286.671875px',
							'2078.375px 1286.671875px',
							'2037.921875px 1198.453125px',
							'2037.921875px 1198.453125px',
							'1998.640625px 1137.328125px',
							'1998.640625px 1137.328125px',
							'1971.796875px 1110.484375px',
							'1971.796875px 1110.484375px',
							'2473.078125px 1249.765625px',
							'2473.078125px 1249.765625px',
							'2921.0625px 1432.859375px',
							'2921.0625px 1432.859375px',
							'3629.21875px 1659.515625px',
							'3629.21875px 1659.515625px',
							'3918.171875px 1754.140625px',
							'3918.171875px 1754.140625px',
							'3943.328125px 1771.5625px',
							'3943.328125px 1771.5625px',
							'3942.171875px 1773.078125px',
							'3942.171875px 1773.078125px',
							'3902.015625px 1756.984375px',
							'3902.015625px 1756.984375px',
							'3889.9375px 1742.796875px',
							'3889.9375px 1742.796875px',
							'3886.875px 1736.671875px',
							'3886.875px 1736.671875px',
							'3861.203125px 1724.96875px',
							'3861.203125px 1724.96875px',
							'3800.640625px 1703.65625px',
							'3800.640625px 1703.65625px',
							'3716.625px 1680.046875px',
							'3716.625px 1680.046875px',
							'3652.25px 1655.5px',
							'3652.25px 1655.5px',
							'3594.03125px 1624.453125px',
							'3594.03125px 1624.453125px',
							'3523.5px 1594.921875px',
							'3523.5px 1594.921875px',
							'3439.484375px 1571.3125px',
							'3439.484375px 1571.3125px',
							'3373.234375px 1551.15625px',
							'3373.234375px 1551.15625px',
							'3355.234375px 1546.359375px',
							'3355.234375px 1546.359375px',
							'3352.546875px 1544.828125px',
							'3352.546875px 1544.828125px',
							'3353.546875px 1544.828125px',
							'3353.546875px 1544.828125px',
							'3364.984375px 1546.921875px',
							'3364.984375px 1546.921875px',
							'3369.53125px 1549.953125px',
							'3369.53125px 1549.953125px',
							'3370.625px 1549.953125px',
							'3370.625px 1549.953125px',
							'3374.796875px 1551.46875px',
							'3374.796875px 1551.46875px',
							'3393.125px 1555.65625px',
							'3393.125px 1555.65625px',
							'3407.25px 1559.84375px',
							'3407.25px 1559.84375px',
							'3413.3125px 1561.359375px',
							'3413.3125px 1561.359375px',
							'3413.3125px 1562.609375px',
							'3413.3125px 1562.609375px',
							'3414.375px 1562.609375px',
							'3414.375px 1562.609375px',
							'3415.46875px 1562.609375px',
							'3415.46875px 1562.609375px',
							'3416.53125px 1562.609375px',
							'3416.53125px 1562.609375px',
							'3418.046875px 1563.859375px',
							'3418.046875px 1563.859375px',
							'3420.703125px 1563.859375px',
							'3420.703125px 1563.859375px',
							'3423.46875px 1565.375px',
							'3423.46875px 1565.375px',
							'3422.96875px 1565.375px',
							'3422.96875px 1565.375px',
							'3414.171875px 1565.375px',
							'3414.171875px 1565.375px',
							'3392.59375px 1565.375px',
							'3392.59375px 1565.375px',
							'3362.53125px 1564.03125px',
							'3362.53125px 1564.03125px',
							'3334.875px 1559.953125px',
							'3334.875px 1559.953125px',
							'3311.890625px 1556.625px',
							'3311.890625px 1556.625px',
							'3291.6875px 1553.828125px',
							'3291.6875px 1553.828125px',
							'3243.359375px 1547.140625px',
							'3243.359375px 1547.140625px',
							'3187.734375px 1540.53125px',
							'3187.734375px 1540.53125px',
							'3139.140625px 1533.796875px',
							'3139.140625px 1533.796875px',
							'3107.375px 1527.125px',
							'3107.375px 1527.125px',
							'3081.6875px 1522.875px',
							'3081.6875px 1522.875px',
							'3065.078125px 1521.640625px',
							'3065.078125px 1521.640625px',
							'3057.71875px 1521.609375px',
							'3057.71875px 1521.609375px',
							'3056.453125px 1521.609375px',
							'3056.453125px 1521.609375px',
							'3056.3125px 1521.609375px',
							'3056.3125px 1521.609375px',
							'3058.625px 1521.609375px',
							'3058.625px 1521.609375px',
							'3074.484375px 1526.375px',
							'3074.484375px 1526.375px',
							'3135.640625px 1540.328125px',
							'3135.640625px 1540.328125px',
							'3204.65625px 1558.34375px',
							'3204.65625px 1558.34375px',
							'3247.453125px 1572.75px',
							'3247.453125px 1572.75px',
							'3282.828125px 1586.078125px',
							'3282.828125px 1586.078125px',
							'3310.78125px 1596.765625px',
							'3310.78125px 1596.765625px',
							'3334.328125px 1607.59375px',
							'3334.328125px 1607.59375px',
							'3361.4375px 1621.84375px',
							'3361.4375px 1621.84375px',
							'3385.921875px 1633.5px',
							'3385.921875px 1633.5px',
							'3396.875px 1640.6875px',
							'3396.875px 1640.6875px',
							'3400.015625px 1642.390625px',
							'3400.015625px 1642.390625px',
							'3401.59375px 1642.59375px',
							'3401.59375px 1642.59375px',
							'3402.375px 1643.265625px',
							'3402.375px 1643.265625px',
							'3402.375px 1644.328125px',
							'3397.9px 1641.1px',
							'3397.6px 1642.4px',
							'3398.625px 1644.21875px',
							'3397.4px 1640.3px',
							'3394.2px 1643.1px',
							'3394px 1642.4px',
							'3382.7px 1637.8px',
							'3381.1px 1638.1px',
							'3362.7px 1626.3px',
							'3365.5px 1629.1px',
							'3364.5px 1625.5px',
							'3342.8px 1618.3px',
							'3347.3px 1623px',
							'3305px 1600.3px',
							'3254.7px 1586.1px',
							'3255.5px 1584.7px',
							'3255.5px 1584.7px',
							'3195px 1568.2px',
							'3195px 1568.2px',
							'3175.34375px 1561.1875px',
							'3170.796875px 1558.546875px',
							'3170.796875px 1558.546875px',
							'3165.5px 1555px',
							'3165.5px 1555px',
							'3165.5px 1555px',
							'3137.7px 1545.9px',
							'3103.6px 1534.8px',
							'3104.7px 1538px',
							'3093.953125px 1533.78125px',
							'3093.953125px 1533.78125px',
							'3092.5625px 1533.75px',
							'3089.3px 1531.3px',
							'3089.34375px 1531.9375px',
							'3089.34375px 1531.9375px',
							'3087.4px 1530.7px',
							'3086.3px 1531.9px',
							'3086.8px 1531.1px',
							'3062.6px 1522.8px',
							'3026px 1511.9px',
							'3023.5px 1511.5px',
							'3010px 1505.9px',
							'3009.9px 1504.6px',
							'3007.1px 1506.7px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</HtmlInCanvas>
	);
};

export const CloseUp4Preview = () => {
	return (
		<CloseUpFrame>
			<CloseUp4Content />
		</CloseUpFrame>
	);
};

export const CloseUp4 = () => {
	return (
		<Composition
			id="EditEasing"
			component={CloseUp4Preview}
			width={1920}
			height={1080}
			fps={60}
			durationInFrames={80}
		/>
	);
};
